<template>
    <div class="checkout-cart mb-4">
        <div v-if="failedOrder && failedOrder.variant=='danger'">
            <bootstrap-alert 
                :variant="failedOrder.variant"
                :msg='this.$t("Sorry your payment failed, please try again with different options")'
                :errorMsg="failedOrder.errmsg"
            />
        </div>

        <b-alert dismissible :show="processError.display" variant="danger">{{ processError.message }}</b-alert>

        <div v-if="proceedLoading"><div class="loading"></div></div>
        <div v-else class="row">
            <div class="col-md-12 your-cart">
                <div class="cart-details ordersummry" v-if="orderDetails.shipping_details">
                    <h2>{{ $t("Order Summary") }}</h2>
                    <div class="alert alert-danger" role="alert" v-if="orderResponse && orderResponse.variant=='danger'">
                        <div class="my-1">
                            {{ $t('Sorry your payment failed, please try again with different options') }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 col-lg-7 order1 billinginformation" >
                            <div class="list-group">
                              <div class="d-flex content-main list-group-item">
                                <div class="content-top" @click="toggleAccordion('billing')">
                                  <span v-if="isMobile" class="text-muted mr-2">
                                    <i v-if="isCollapsedBilling" class="fa fa-chevron-down"></i>
                                    <i v-else class="fa fa-chevron-up"></i>
                                  </span>
                                  <small class="text-muted">{{ $t("Billing information") }}</small>
                                </div>
                                <div :class="['content-middle', isMobile && !isCollapsedBilling ? 'collapse show' : '', isMobile && isCollapsedBilling ? 'collapse' : '']">
                                  <p class="mb-0 font-14">{{orderDetails.billing_details.first_name}} {{orderDetails.billing_details.last_name}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.billing_details.email}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.billing_details.contact_number}}</p>
                                </div>
                                <div class="ml-auto content-last">
                                  <a href="javascript:void(0);" @click="backToInformation()">{{ $t('Change')}}</a>
                                </div>
                              </div>
                              <div class="d-flex content-main list-group-item" v-if="orderDetails.licence_plate && orderDetails.licence_plate !== null && orderDetails.licence_plate !== 'null'">
                                <div class="content-top" @click="toggleAccordion('Licence Plate')">
                                  <span v-if="isMobile" class="text-muted mr-2">
                                    <i v-if="isCollapsedLicensePlace" class="fa fa-chevron-down"></i>
                                    <i v-else class="fa fa-chevron-up"></i>
                                  </span>
                                  <small class="text-muted">{{ $t("Licence Plate") }}</small>
                                </div>
                                <div :class="['content-middle', isMobile && !isCollapsedLicensePlace ? 'collapse show' : '', isMobile && isCollapsedLicensePlace ? 'collapse' : '']">
                                  <p class="mb-0 font-14">{{orderDetails.licence_plate}}</p>
                                </div>
                                <div class="ml-auto content-last">
                                  <a href="javascript:void(0);" @click="backToInformation()">{{ $t('Change')}}</a>
                                </div>
                              </div>
                              <div class="d-flex content-main list-group-item" v-if="orderDetails.order_note && orderDetails.order_note !== null && orderDetails.order_note !== 'null'">
                                <div class="content-top" @click="toggleAccordion('Order Note')">
                                  <span v-if="isMobile" class="text-muted mr-2">
                                    <i v-if="isCollapsedOrderNote" class="fa fa-chevron-down"></i>
                                    <i v-else class="fa fa-chevron-up"></i>
                                  </span>
                                  <small class="text-muted">{{ $t("Order Note") }}</small>
                                </div>
                                <div :class="['content-middle', isMobile && !isCollapsedOrderNote ? 'collapse show' : '', isMobile && isCollapsedOrderNote ? 'collapse' : '']">
                                  <p class="mb-0 font-14">{{orderDetails.order_note}}</p>
                                </div>
                                <div class="ml-auto content-last">
                                  <a href="javascript:void(0);" @click="backToInformation()">{{ $t('Change')}}</a>
                                </div>
                              </div>
                              <div class="d-flex content-main list-group-item" v-if="showShipping || !hasServices(orderDetails.line_items)">
                                <div class="content-top" @click="toggleAccordion('shipping')">
                                  <span v-if="isMobile" class="text-muted mr-2">
                                    <i v-if="isCollapsedShipping" class="fa fa-chevron-down"></i>
                                    <i v-else class="fa fa-chevron-up"></i>
                                  </span>
                                  <small class="text-muted">{{ $t("Shipping information") }}</small>
                                </div>
                                <div :class="['content-middle', isMobile && !isCollapsedShipping ? 'collapse show' : '', isMobile && isCollapsedShipping ? 'collapse' : '']">
                                  <p class="mb-0 font-14" v-if="orderDetails.service_point_shipment_details">{{orderDetails.service_point_shipment_details.company_name}}</p>
                                  <p class="mb-0 font-14" v-else>{{orderDetails.shipping_details.first_name}} {{orderDetails.shipping_details.last_name}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.shipping_details.email}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.shipping_details.contact_number}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.shipping_details.address_line_1}}</p>
                                  <p class="mb-0 font-14">{{orderDetails.shipping_details.zipcode}} {{ orderDetails.shipping_details.city }}</p>
                                </div>
                                <div class="ml-auto content-last">
                                  <a href="javascript:void(0);" @click="backToInformation()">{{ $t('Change')}}</a>
                                </div>
                              </div>

                              <div class="d-flex flex-column list-group-item" v-if="orderDetails.appointment && hasServices(orderDetails.line_items)">
                                <div class="d-flex content-main">
                                  <div class="content-top w-50" @click="toggleAccordion('Service Point')">
                                    <p class="font-weight-bold text-muted font-14 mb-2">
                                      <span v-if="isMobile" class="text-muted mr-2">
                                        <i v-if="isCollapsedServicePoint" class="fa fa-chevron-down"></i>
                                        <i v-else class="fa fa-chevron-up"></i>
                                      </span>
                                      {{ $t("Appointment and shipping address") }}
                                    </p>
                                  </div>
                                  <div class="ml-auto content-last">
                                    <a href="javascript:void(0);" @click="backToServicePoint()">{{ $t('Change')}}</a>
                                  </div>
                                </div>
                                <div class="d-flex content-main" :class="[isMobile && !isCollapsedServicePoint ? 'show' : '', isMobile && isCollapsedServicePoint ? 'hide' : '']">
                                  <div class="content-top">
                                    <small class="text-muted">{{ $t("Service point") }}</small>
                                  </div>
                                  <div class="content-middle">
                                    <p class="mb-0 font-14">{{orderDetails.appointment.dealer.company_name}}</p>
                                  </div>
                                </div>
                                <div class="d-flex content-main" :class="[isMobile && !isCollapsedServicePoint ? 'show' : '', isMobile && isCollapsedServicePoint ? 'hide' : '']">
                                  <div class="content-top">
                                    <small class="text-muted">{{ $t("Contact Info") }}</small>
                                  </div>
                                  <div class="content-middle">
                                    <p class="mb-0 font-14">{{ orderDetails.appointment.dealer.contact_number}}, {{ orderDetails.appointment.dealer.email}}</p>
                                  </div>
                                </div>
                                <div class="d-flex content-main" :class="[isMobile && !isCollapsedServicePoint ? 'show' : '', isMobile && isCollapsedServicePoint ? 'hide' : '']" v-if="orderDetails.appointment.schedule_date !== null && orderDetails.appointment.start_time !== null && orderDetails.appointment.end_time !== null">
                                  <div class="content-top">
                                    <small class="text-muted">{{ $t("Date and Time") }}</small>
                                  </div>
                                  <div class="content-middle">
                                    <p class="mb-0 font-14">{{ formatDate(orderDetails.appointment.schedule_date) }} <span class="font-weight-bold">,</span> {{ formatTime(orderDetails.appointment.start_time) }} - {{ formatTime(orderDetails.appointment.end_time) }}</p>
                                  </div>
                                </div>
                                <div class="d-flex content-main" :class="[isMobile && !isCollapsedServicePoint ? 'show' : '', isMobile && isCollapsedServicePoint ? 'hide' : '']">
                                  <div class="content-top">
                                    <small class="text-muted">{{ $t("Address") }}</small>
                                  </div>
                                  <div class="content-middle">
                                    <p class="mb-0 font-14">
                                      {{ orderDetails.appointment.dealer.address_line_1 }}
                                      <span v-if="orderDetails.appointment.dealer.address_line_2 && orderDetails.appointment.dealer.address_line_2 !== 'null'">
                                      , {{ orderDetails.appointment.dealer.address_line_2 }}
                                      </span>
                                      <span>, {{ orderDetails.appointment.dealer.zipcode }} - {{ orderDetails.appointment.dealer.city }}</span>
                                    </p>


                                  </div>
                                </div>
                                <div class="d-flex content-main" v-if="orderDetails.appointment.schedule_date === null && orderDetails.appointment.start_time === null && orderDetails.appointment.end_time === null">
                                  <div>
                                    <p class="font-weight-bold pricedata">{{ $t("This service point doesn't have calendar, Please use contact details to take appointment for pickup and services.") }}</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <b-row>
                              <b-col cols="12" class="my-3">
                                <h4> {{ $t('Payment')}} </h4>
                                <p> {{ $t('All transactions are secure and encrypted')}}. </p>
                                <material-list-group v-model="payment_by" />
                              </b-col>
                            </b-row>
                            <div class="row orderbtns">
                              <div class="col-sm-12 col-md-6 pl-0 align-items-center d-flex order-2 order-md-1">
                                <a href="javascript:void(0);" @click="backToInformation()" class="btn btn-link left-link text-muted font-14">
                                  <i class="fa fa-arrow-left"></i>
                                  <span class="pl-2">{{ $t("Back to information") }}</span>
                                </a>
                              </div>
                              <div class="col-sm-12 col-md-6 order-1 align-items-start order-md-2 text-right">
                                <b-button :disabled="((userOrder.length && !userOrder.conditions) && !userDetails) || (!orderDetails.length && !orderDetails.total) || payments.indexOf(payment_by) === -1" class="color-white rounded btn-block bg-green py-3" @click="makePayment()">
                                  <span class="text-uppercase pb-1">{{ $t("Pay now safely") }}</span>
                                </b-button>
                              </div>
                            </div>
                        </div>

                        <div class="col-md-12 col-lg-5 order3 bag-details">
                            <h3 class="border-top border-bottom py-2">{{ $t("Items in your bag") }}</h3>
                            <div class="mt-3">
                                <div v-for="(lineItem, index) in orderDetails.line_items"  :key="'product-'+index">
                                    <div  class="row font-14 mb-3"  v-if="lineItem.type=='product'">
                                        <div class="col-2 pr-0">
                                            <div v-if="lineItem.product.images && lineItem.product.images.length != 0 && lineItem.product.images != null">
                                                <b-img :src="lineItem.product.images[0].image_base_path+lineItem.product.images[0].path" v-bind="{ width: 60 }"></b-img>
                                            </div>
                                            <div v-else>
                                                <b-img :src="'/images/no-data-found.png'" v-bind="{ width: 60 }"></b-img>
                                            </div>
                                        </div>
                                        <div class="col-7 pl-0">
                                            <h3>{{ lineItem.product.name }}</h3>
                                            <p class="mb-1"><span v-html="setCurrency(lineItem.product.net_price_with_rc)"></span> | {{ $t("Qty") }} - {{ lineItem.quantity }}</p>
                                            <div class="rc-label" v-if="lineItem.product.is_recycled == '0'">
                                                <small>({{ $t('Recycling fee included') }})</small>
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <p class="mb-0 font-weight-bold text-right pricedata"><span v-html="setCurrencyTotalQtyPrice(lineItem.product.net_price_with_rc * lineItem.quantity)"></span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-if="hasServices(orderDetails.line_items)" class="pt-3">
                               <h3 class="col-12 pl-0 py-2 border-top border-bottom">{{ $t("Services") }}</h3>
                               <div v-for="(lineItem, index) in orderDetails.line_items"  :key="'services-'+index">
                                    <div class="row orderinfo font-14 mb-2 border-0" v-if="lineItem.type=='service'">
                                        <div class="col-9 mb-2">
                                            <p class="mb-1"> {{ getServiceName(lineItem) }}</p>
                                            <p class="mb-1"><span v-html="setCurrency(lineItem.unit_price)"></span> | {{ $t("Qty") }} - {{ lineItem.quantity}}</p>
                                        </div>
                                        <div class="col-3">
                                            <p class="mb-0 font-weight-bold text-right pricedata"><span v-html="setCurrency(lineItem.sub_total)"></span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="border-bottom border-top pt-3">
                                <div v-for="(lineItem, index) in orderDetails.line_items" :key="'charges-'+index">
                                    <div class="row font-14 mb-2" v-if="lineItem && (lineItem.type=='recycling_charges' || lineItem.type=='shipping_charges')">
                                        <!-- <div class="col-9 mb-1" v-if="lineItem && lineItem.type=='recycling_charges'">
                                            <p class="mb-1">{{ $t('Recycling Fees') }}</p>
                                            <p class="mb-1"><span v-html="setCurrency(lineItem.unit_price)"></span> | {{ $t('Qty') }} - <span v-html="setCurrencyRecyclingTotalQty()"></span></p>
                                        </div>
                                        <div class="col-3" v-if="lineItem && lineItem.type=='recycling_charges'">
                                            <p class="mb-0 font-weight-bold text-right pricedata"><span v-html="setCurrency(lineItem.sub_total)"></span></p>
                                        </div> -->
                                        <div class="col-9 mb-1" v-if="lineItem && lineItem.type=='shipping_charges'">
                                            <p class="mb-1">{{ $t('Shipping charges') }}</p>
                                        </div>
                                        <div class="col-3" v-if="lineItem && lineItem.type=='shipping_charges'">
                                            <p class="mb-0 font-weight-bold text-right pricedata"><span v-html="setCurrency(lineItem.sub_total)"></span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="border-bottom pt-3" v-if="orderDetails.promo_code_id">
                                <div class="row font-14 mb-2">
                                    <div class="col-9 mb-1" v-if="orderDetails.promo_code_id">
                                        <p class="mb-1">{{ $t('Discount') }}</p>
                                    </div>
                                    <div class="col-3" v-if="orderDetails.promo_code_id">
                                        <p class="mb-0 font-weight-bold text-right pricedata"><span v-html="setCurrency(orderDetails.discount_amount)"></span></p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 order-totalprice text-right pt-3 pb-3">
                                    <p>{{ $t("Total Price")}}: <span v-html="setCurrency(orderDetails.total)"></span></p>
                                    <p class="vatamount">{{ $t("Vat Amount")}}: <span v-html="setCurrency(orderDetails.vat_amount)"></span></p>
                                </div>
                            </div>
                        </div> 
                           
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.lh-5 {
    line-height: 0.5px;
    margin-bottom: 1.5rem;
}
.content-main {
}

.content-top {
    width: 20%;
    order: 1;
}
.content-middle {
    order: 2;
    width: 50%;
}
.content-last {
    order: 3;
    width: 20%;
    text-align: right;
}
.content-last a {
  font-size: 14px;
  color: #da9d26;
  text-decoration: underline;
}
@media (max-width: 767px) {
  .content-main {
    flex-wrap: wrap;
  }
  .content-main.hide {
    display:none !important;
  }
  .content-top {
    width: 50%;
    padding-top: 5px;
    cursor: pointer;
  }
  .content-middle {
    order: 3;
    width: 100%;
    flex: 1 1 100%;
    background: rgba(227, 227, 227, 0.37);
    padding: 0.5rem;
  }
  .content-last {
    order: 2;
    width: 50%;
    padding: 5px;
    text-align: right;
  }
  .content-top, .content-last {
    flex: 1 1 50%; /* First and last div take half width */
  }
}

@media (max-width: 991px) {
  .bag-details {
      display: none;
  }
}

</style>
<script>
import { mapGetters, mapActions } from "vuex";
import MaterialListGroup from "./layouts/MaterialListGroup.vue";
export default {
    name: 'TabOrderSummary',
    props: {
        showShipping:Boolean,
    },
    components : {
      MaterialListGroup
    },
    created() {
        this.SetPaymentBy()
        if (this.$route.query.sid) {
          if(this.$route.params.orderNumber) {
            this.$router.push({
              path: '/cart/order-summary/'+ this.$route.params.orderNumber,
              name:'order-summary',
              params:{'orderNumber' : this.$route.params.orderNumber}
            })
          }
        }
        this.failedOrder = {}
        this.moneySign = process.env.VUE_APP_CURRENCY_SIGN;
        this.getAllCartProducts();
        if(this.$route.params.status && this.$route.params.status.search('failed')>-1
        && this.$route.query  && this.$route.query.ORDER_NUMBER
        &&  typeof(this.$route.query.ORDER_NUMBER)!=='undefined') {
            this.getDetailsByOrderNumber(this.$route.query.ORDER_NUMBER)
            this.$emit('update-tab', 'Order Summary')
        } else if(typeof(this.$route.params.orderNumber)!=='undefined') {
            this.getDetailsByOrderNumber(this.$route.params.orderNumber)
            this.$emit('update-tab', 'Order Summary')
        } else if (typeof(this.orderDetails.order_number)!=='undefined') {
            this.getDetailsByOrderNumber(this.orderDetails.order_number)
            this.$emit('update-tab', 'Order Summary')
        }
    },
    computed: {
        ...mapGetters('app', ['currentLang']),
        ...mapGetters('auth', ['userDetails', 'userDetailsAddress']),
        ...mapGetters('cart', ['cartProducts']),
        ...mapGetters('order', ['orderResponse','userOrder','orderDetails', 'paymentDetails', 'proceedLoading','currentLang']),
        ...mapGetters('appointments', ['appointmentDetails']),
    },
    data() {
        return {
            moneySign: "€",
            totalRecycleQty: 0,
            orderNumber: (this.$router.params && this.$router.params.orderNumber)?this.$router.params.orderNumber:null,
            orderError: null,
            serviceName:[],
            failedOrder: {},
            paymentStatus: null,
            processError: { display: false, message: '' },
            payment_by : '',
            payments : ['bank', 'creditcard', 'apple-pay', 'mobile', 'klarna'],
            isMobile: false,   // Flag to detect if it's a mobile view
            isCollapsedBilling: true, // Flag to manage accordion state (collapsed or not)
            isCollapsedShipping: true, // Flag to manage accordion state (collapsed or not)
            isCollapsedLicensePlace: true, // Flag to manage accordion state (collapsed or not)
            isCollapsedOrderNote: true, // Flag to manage accordion state (collapsed or not)
            isCollapsedServicePoint: true, // Flag to manage accordion state (collapsed or not)
        }
    },
    watch:{
        "currentLang": {
            handler() {
                if(this.$route.params.orderNumber) {
                    this.$router.push({
                        path: '/cart/order-summary/'+ this.$route.params.orderNumber,
                         name:'order-summary',
                        params:{'orderNumber' : this.$route.params.orderNumber}
                    })
                }
                
            }
        },
        payment_by : {
          handler(NewPaymentType) {
            localStorage.setItem('payment_by', NewPaymentType)
          }
        }
    },
    methods: {
        ...mapActions('cart', ['getAllCartProducts']),
        ...mapActions('order', ['processPaymentWithPaytrail', 'getDetailsByOrderNumber', 'processPaymentWithKlarna']),
        checkScreenSize() {
          // Check if the screen width is less than 992px
          this.isMobile = window.innerWidth <= 767;

          // If it's a large screen, make sure the accordion is open
          if (!this.isMobile) {
            this.isCollapsedBilling = false;
            this.isCollapsedShipping = false;
            this.isCollapsedLicensePlace = false;
            this.isCollapsedOrderNote = false;
            this.isCollapsedServicePoint = false;
          } else {
            // Collapse the accordion on mobile by default
            this.isCollapsedBilling = true;
            this.isCollapsedShipping = true;
            this.isCollapsedLicensePlace = true;
            this.isCollapsedOrderNote = true;
            this.isCollapsedServicePoint = true;
          }
        },
        toggleAccordion(Type) {
          // Toggle the collapsed state when in mobile view
          if (this.isMobile) {
            if (Type === 'billing') {
              this.isCollapsedBilling = !this.isCollapsedBilling;
            }

            if (Type === 'shipping') {
              this.isCollapsedShipping = !this.isCollapsedShipping;
            }

            if (Type === 'Licence Plate') {
              this.isCollapsedLicensePlace = !this.isCollapsedLicensePlace;
            }

            if (Type === 'Order Note') {
              this.isCollapsedOrderNote = !this.isCollapsedOrderNote;
            }

            if (Type === 'Service Point') {
              this.isCollapsedServicePoint = !this.isCollapsedServicePoint;
            }
          }
        },
        processPayment() {
            let processData = new FormData();
            processData.append('order_id', this.orderDetails.id);
            processData.append('payment_by', this.payment_by);
            this.processPaymentWithPaytrail(processData)
            .then( () => {
                if(this.paymentDetails.url) {

                    var gtag_products = [];

                    this.orderDetails.line_items.forEach(function(product) {
                        
                        if (product.type == "product") {
                            gtag_products.push({
                                'item_id': product.id,
                                'item_name': product.product.name,
                                'affiliation' : product.type,
                                'price': product.unit_price,
                                'type_id': product.type_id,
                                'quantity': product.quantity,
                                'item_category': product.product.car_type
                            })
                        }
                    })

                    // // gtag add payment info
                    // this.googleTagAddPaymentInfo(this.orderDetails.total, gtag_products);

                    // this.$gtag.event("add_payment_info", {
                    //     currency: "€",
                    //     value: this.orderDetails.total,
                    //     coupon: "",
                    //     payment_type: "Credit Card",
                    //     items: gtag_products
                    // });
                    
                    // gtag begin checkout
                    this.googleTagBeginCheckout(this.orderDetails.total, gtag_products);

                    // this.$gtag.event("begin_checkout", {
                    //     currency: "€",
                    //     value: this.orderDetails.total,
                    //     coupon: "",
                    //     items: gtag_products
                    // });

                    window.location.href = this.paymentDetails.url;
                }
            }).catch(error => {
                this.processError.display = true
                this.processError.message = error.response.data.errors[0]
                window.scrollTo(0,0)
            });
        },
        backToInformation() {
            this.$router.push({
                path: '/cart/user-info',
                params:{},
                replace: true
            });
        },
        backToServicePoint() {
          this.$router.push({ path: "/cart/dealer-services", name: "dealer-services", params: {} });
          window.scrollTo(0, 0);
        },
        setCurrency(total) {
            if(total) {
                // return this.moneySign + total.replace(".", ",")
                return total.replace(".", ",") + " " + this.moneySign
            }
            return "-"
        },
        setCurrencyTotalQtyPrice(price) {
            if(price) {
                price = parseFloat(price).toFixed(2) 
            }
            // return this.moneySign + price.toString().replace(".", ",")
            return price.toString().replace(".", ",") + " " + this.moneySign
           
        },
        setCurrencyRecyclingTotalQty() {
          
            var totalRecycleQty = 0;

            this.cartProducts.find((el) => {
                totalRecycleQty += el.qty;
            })

            this.totalRecycleQty = totalRecycleQty;


            return this.totalRecycleQty;
        },
        getServiceName(cartItem){
            let service_name = ''
            if(cartItem.service && cartItem.service.translations) {
                for(let sKey in cartItem.service.translations) {
                    if(cartItem.service.translations[sKey] && cartItem.service.translations[sKey].locale_code == this.currentLang) {
                        service_name = cartItem.service.translations[sKey].name
                    }
                    
                }

            }
            if(service_name!='' && cartItem.service
            && cartItem.service.is_price_per_quantity
            && cartItem.sub_type_id) {
                service_name = service_name + '-' + cartItem.sub_type_id+' '+ this.$t('Inch')
            }
            return service_name
        },
        hasServices(lineItems) {
            const productIndex = _.findIndex(lineItems, function(lineItem)
                { 
                    return lineItem.type == 'service'; 
                }
            );
            if(productIndex >0 ){
                return true
            }
            return false
        },
        formatTime(time) {
            if(time) {
                time = time.substr(0, time.lastIndexOf(":00"))
            }
            return time
        },
        formatDate(scheduleDate) {
            if(scheduleDate!='') {
                let sDate = new Date(scheduleDate)
                let month = sDate.getMonth()+1 < 10 ? '0'+(sDate.getMonth()+1) : (sDate.getMonth()+1)
                let dm = sDate.getDate()<10?'0'+(sDate.getDate()):+(sDate.getDate())
                sDate = dm + '-' + month + '-' + sDate.getFullYear()
                return sDate;
            }
            return scheduleDate
        },
        async payWithKlarna() {
          let processData = new FormData();
          processData.append('order_id', this.orderDetails.id);
          await this.processPaymentWithKlarna(processData).then(() => {
            if(this.paymentDetails.url) {

              var gtag_products = [];

              this.orderDetails.line_items.forEach(function(product) {
                if (product.type == "product") {
                  gtag_products.push({
                    'item_id': product.id,
                    'item_name': product.product.name,
                    'affiliation' : product.type,
                    'price': product.unit_price,
                    'type_id': product.type_id,
                    'quantity': product.quantity,
                    'item_category': product.product.car_type
                  })
                }
              })

              this.googleTagBeginCheckout(this.orderDetails.total, gtag_products);

              window.location.href = this.paymentDetails.url;
            }
          }).catch(error => {
            this.processError.display = true
            this.processError.message = error.response.data.errors[0]
            window.scrollTo(0,0)
          });
        },
        SetPaymentBy() {
            let PaymentBy = ''
            if ("payment_by" in localStorage && localStorage.getItem("payment_by")) {
                PaymentBy = localStorage.getItem("payment_by")
            }
            this.payment_by = PaymentBy;
        },
        makePayment() {
          this.klaviyoStartedCheckout(this.orderDetails)
          if (['bank', 'creditcard', 'apple-pay', 'mobile'].indexOf(this.payment_by)  !== -1) {
            this.processPayment()
          } else if (this.payment_by === 'klarna') {
            this.payWithKlarna()
          }
        }
    },
    mounted() {
      // Run the screen size check when the component is mounted
      this.checkScreenSize();

      // Add an event listener to handle window resize
      window.addEventListener('resize', this.checkScreenSize);
    },
    beforeDestroy() {
      // Clean up the resize event listener
      window.removeEventListener('resize', this.checkScreenSize);
    }
}
</script>